export const defaultContent = (
  <>
    <span>345k+ 5-star Prose product reviews </span>
    <span>on Review & Refine™</span>
  </>
);

export const noFreeShippingContent = 'Limited offer: free starter kit, only pay for shipping';
export const referralCta = 'Refer a friend';
export const membershipCta = 'Subscribe for 15% off + free products. Cancel anytime.';
export const membershipCheckout = 'Join the Salon to save 15% on this and every order';

export const vanityUrlDailypop =
  'Hi DailyPop Viewers! $10 off your first order will be applied at cart';
